import auth from './auth/reducer';
import offers from './offers/reducer';
import profile from './profile/reducer';
import requests from './requests/reducer';
import timeline from './timeline/reducer';

export default {
  auth,
  offers,
  profile,
  requests,
  timeline,
};
